import { useContext } from 'react';
import { FormContext } from '~/components/forms/FormContext.jsx';
import { isAdminApp } from '~/public/lib/PageHelpers.js';
import { useBusinessInfo } from '~/lib/Queries';
import { ConfirmationContext } from '~/lib/ConfirmationContext.js';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';

const useWeekStart = () => {
    // Yes.. I know this is dangerous to have in conditionals
    //  but this should never change since it's based on the page container

    const business = useCurrentBusiness();
    const weekStart = business?.week_start;

    return typeof weekStart === 'undefined' ? 1 : parseInt(weekStart);
};

export default useWeekStart;
